import { Loading, Modal } from "@quark/design";
import { FC, ReactNode, useEffect, useState } from "react";
import { LOGIN_EVENT, LOGIN_SUCCESS } from "../../constants";
import useWechatLogin from "../../hooks/use-wechat-login";
import { isEmpty } from "../../utils";

const LoginQrCode = () => {
  const { qrcode } = useWechatLogin();

  if (isEmpty(qrcode)) {
    return <Loading />;
  }

  return (
    <>
      <img src={qrcode} width={300} height={300} alt="" />
      <div>请用微信扫一扫后确认登录</div>
    </>
  );
};

interface LoginWrapperProps {
  children: ReactNode;
}

const LoginWrapper: FC<LoginWrapperProps> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  // const iframe = useRef<HTMLIFrameElement>(null);
  // const [loginStamp] = useState("loginSuccess");

  // const redirectUrl = useMemo(() => {
  //   if (visible) {
  //     const { href } = window.location;
  //     return `${href}?${loginStamp}=true`;
  //   }
  //   return "";
  // }, [visible, loginStamp]);

  // const loginUrl = useMemo(() => {
  //   if (visible) {
  //     return `//edu.py2fun.com/login?redirect_url=${encodeURIComponent(
  //       redirectUrl
  //     )}`;
  //   }
  //   return "";
  // }, [visible, redirectUrl]);

  // const iframeLoad = (e: any) => {
  //   try {
  //     const currentUrl = iframe.current?.contentWindow?.location.href;
  //     console.log("href", currentUrl);
  //     if (currentUrl === redirectUrl) {
  //       setVisible(false);
  //       window.location.reload();
  //     }
  //   } catch (e) {
  //     // do nothing
  //   }
  // };

  useEffect(() => {
    const showLoginModal = () => {
      setVisible(true);
    };

    const loginSuccess = () => {
      setVisible(false);
      window.location.reload();
    };

    window.addEventListener(LOGIN_EVENT, showLoginModal);
    window.addEventListener(LOGIN_SUCCESS, loginSuccess);

    return () => {
      window.removeEventListener(LOGIN_EVENT, showLoginModal);
      window.removeEventListener(LOGIN_SUCCESS, loginSuccess);
    };
  }, []);

  return (
    <>
      {children}
      {/* <Modal
        title="PythonTip 登陆"
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <iframe
          title="login-frame"
          ref={iframe}
          width={400}
          height={400}
          src={loginUrl}
          style={{ border: "none" }}
          onLoad={iframeLoad}
        />
      </Modal> */}
      <Modal
        title="【用户登录】哈希编程 PythonTip学编程"
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <div style={{ textAlign: "center" }}>
          <LoginQrCode />
        </div>
      </Modal>
    </>
  );
};

export default LoginWrapper;
